import { pageInfo, exportData} from './../api';
import { Message } from 'element-ui';
import {plant, storageList} from "../../../../api";
const reshipCornOrder = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    exportObj: [],
    plantObj: [],
    storageObj: []
  },
  mutations: {
    PAGE_INFO(state,data){
      state.total = data.total;
      state.pageResp = data.obj || [];
    },
    EXPORT_DATA(state, data) {
      state.exportObj = data;
    },
    PLANT(state, data) {
      state.plantObj = data;
    },
    STORAGE(state, data){
      state.storageObj = data;
    }
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj){
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async exportData({commit}, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    async plant({commit}, obj) {
      let resp = await plant(obj);
      commit('PLANT', resp);
    },
    async storage({commit}, obj) {
      let resp = await storageList(obj);
      commit('STORAGE', resp);
    },
  }
}
export default reshipCornOrder



// WEBPACK FOOTER //
// ./src/page/report/reshipCornOrder/store/reshipCorn.store.js